import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Admin } from '../../../clients/quipli-service/admin/admin';
import Icon from '../../../components/icons/icon';
import { Typography } from '../../../components/typography/typography';
import './admin-user.scss';
import { AdminUserForm } from '../components/admin-user-form';
import { toast } from '../../../util/toasts';
import { useAdminApiV1 } from '../../../clients/quipli-service/admin/admin-api-v1';

export const AdminProfile = () => {
  const { getAdminLoggedProfile } = useAdminApiV1();

  const navigate = useNavigate();

  const update = () => {
    toast('User was updated successfully');
  };

  const [adminUser, setAdminUser] = useState<Admin>(),
    [isLoading, setIsLoading] = useState<boolean>(true);

  const init = async () => {
    setIsLoading(true);
    Promise.all([getAdminLoggedProfile()]).then(([adminUser]) => {
      setAdminUser(adminUser);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="admin-user">
      <div className="container-v2">
        <div onClick={() => navigate(-1)}>
          <Icon icon="Back" size="large" />
        </div>
        <div className="flex justify-between items-center mb-5">
          <Typography type="display-sm" weight="medium">
            My Profile
          </Typography>
        </div>
        {!isLoading && <AdminUserForm className="card" type="setup" setNewUser={update} adminUser={adminUser} />}
      </div>
    </div>
  );
};
